module.exports = __webpack_public_path__ + "static/media/19-2.bfbd8619.mp3";